$shm_hitalama_benchmarks_page_metrics_delete $mol_pick
	hint \Удалить строку
	trigger_enabled <= enabled true
	align \bottom_left
	trigger_content /
		<= Icon $mol_icon_delete
	bubble_content /
		<= Content $mol_view
			sub /
				<= Question $mol_text
					text \Удалить?
				<= Confirm $mol_button_minor
					title \Да
					click? <=> confirm? null
				<= Cancel $mol_button_minor
					title \Нет
					click? <=> cancel? null
	remove? null
